import { ChangeDetectionStrategy, Component, HostBinding, Inject, Optional, ViewEncapsulation } from "@angular/core";
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/legacy-dialog";
import { Store } from "@ngrx/store";
import { CoreState, CustomerManagementSelector } from "@obg/ngx.core";
import { Observable, of } from "rxjs";
import { filter, map, take } from "rxjs/operators";

import { CafAuthDialog } from "./caf-face-authenticator.model";

@Component({
	selector: "obg-m-caf-face-authenticator",
	styleUrls: ["./caf-face-authenticator.container.scss"],
	templateUrl: "./caf-face-authenticator.container.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class CafFaceAuthenticatorContainer {
	@HostBinding("class.obg-m-verification-dialog") hostCssClass = true;
	@HostBinding("attr.test-id") testId = "verification-dialog-modal";

	cpfNumber$: Observable<string> | undefined;

	constructor(
		private store: Store<CoreState>,
		@Optional() @Inject(MAT_DIALOG_DATA) public data: CafAuthDialog
	) {
		const externalCPF = this.data?.cpf;
		this.cpfNumber$ =
			externalCPF !== undefined
				? of(externalCPF.replace(/\D/g, ""))
				: this.store.select(CustomerManagementSelector.getCustomer).pipe(
						filter((customer) => !!customer && customer?.profile.personalCode !== undefined),
						take(1),
						map((customer) => String(customer?.profile.personalCode).replace(/\D/g, ""))
					);
	}
}
